import {
  BranchTagsService,    
  type PostBranchTagRequestAdmin,    
  type PutBranchesRequestAdmin,
  type PutBranchTagRequestAdmin, 
} from '@/backend/market'
import { BranchTagsRepository } from '../../domain/repositories/BranchTagsRepository'
import { BranchTagsModel } from '../models/BranchTagsModel'
import type { BranchTagsFilterEntity } from '../../domain/entities/BranchTagsFilterEntity'
import type { CreateUpdateBranchTagEntity } from '../../domain/entities/CreateUpdateBranchTagEntity'
import type { BranchTagsResponseEntity } from '../../domain/entities/BranchResponseEntity'
import { BranchTagsResponseModel } from '../models/BranchTagsResponseModel'
import type { BranchTagsEntity } from '../../domain/entities/BranchTagsEntity'
import { BranchTagsFilterModel } from '../models/BranchTagsFilterModel'
import { CreateUpdateBranchTagModel } from '../models/CreateUpdateBranchTagModel'
import { getChannelCase } from '@/features/channel/domain/usecases/getChannelUsecase'

export class BranchTagsRepositoryImpl implements BranchTagsRepository {
  async getBranchTags(
    filterData: BranchTagsFilterEntity
  ): Promise<BranchTagsResponseEntity | { error: true }> {
    const branchTagsFilterModel = new BranchTagsFilterModel(filterData)
    try {
      const response = await BranchTagsService.getBranchTagsAdmin(branchTagsFilterModel)
      const branchTagsResponseModel = new BranchTagsResponseModel(response as BranchTagsResponseEntity)
      return branchTagsResponseModel
    } catch {
      return { error: true }
    }
  }

  async getBranchTag(id: number): Promise<BranchTagsEntity | { error: true }> {
    try {
      const response = await BranchTagsService.getBranchTagAdmin({ id })
      const channelResponse = await getChannelCase(response.channelId!)
        const branchesResponse = await BranchTagsService.getBranchesByBranchTagAdmin({
        branchTagId: id
      })
 
      const result = {
        ...response,
        channel: channelResponse,
        branches: branchesResponse.items
      }
      const branchTagsModel = new BranchTagsModel(result)
      return branchTagsModel
    } catch {
      return { error: true }
    }
  }

  async createBranchTag(
    data: CreateUpdateBranchTagEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      const createUpdateBranchTagModel = new CreateUpdateBranchTagModel(data)
      await BranchTagsService.postBranchTagAdmin({
        requestBody: createUpdateBranchTagModel as PostBranchTagRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async updateBranchTag(
    id: number,
    data: CreateUpdateBranchTagEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      const createUpdateBranchTagModel = new CreateUpdateBranchTagModel(data)
      await BranchTagsService.putBranchTagAdmin({
        id,
        requestBody: createUpdateBranchTagModel as PutBranchTagRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async updateBranchesDependBranchTag(
    id: number,
    data: { branchIds: number[] }
  ): Promise<{ success: true } | { error: true }> {
    try {
       await BranchTagsService.putBranchesAdmin({
        branchTagId: id,
        requestBody: {
          branchIds: data.branchIds
        } as PutBranchesRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async deleteBranchTag(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await BranchTagsService.deleteBranchTagAdmin({ id })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
 

}
